import { render, staticRenderFns } from "./ContactTypes.vue?vue&type=template&id=9127eac6&scoped=true"
import script from "./ContactTypes.vue?vue&type=script&lang=js"
export * from "./ContactTypes.vue?vue&type=script&lang=js"
import style0 from "./ContactTypes.vue?vue&type=style&index=0&id=9127eac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9127eac6",
  null
  
)

export default component.exports